import React from "react";

//Indicador de progreso. Recibe la lista de nombres de pasos y el paso actual
//(empezando en 1). Se marca como una lista ordenada dentro de un <nav> para
//que los lectores de pantalla anuncien el progreso; el paso actual lleva
//aria-current="step" y cada paso un texto sr-only con su estado.
const PasosVotacion = ({ pasos, pasoActual, etiqueta = "Progreso" }) => {
  return (
    <nav aria-label={etiqueta}>
      <ol className="pasos-votacion">
        {pasos.map((nombre, i) => {
          const numero = i + 1;
          const estado =
            numero < pasoActual
              ? "completado"
              : numero === pasoActual
              ? "actual"
              : "pendiente";
          const textoEstado =
            estado === "completado"
              ? "Completado: "
              : estado === "actual"
              ? "Paso actual: "
              : "Paso pendiente: ";
          return (
            <li
              className={`paso ${estado}`}
              key={nombre}
              aria-current={estado === "actual" ? "step" : undefined}
            >
              <span className="paso-circulo" aria-hidden="true">
                {numero < pasoActual ? "✓" : numero}
              </span>
              <span className="paso-nombre">
                <span className="sr-only">{textoEstado}</span>
                {nombre}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default PasosVotacion;
